// src/i18n/translations/en.js
const translations = {
  brand: "Brand",
  category: "Category",
  type: "Type",
  cargo_capacity: "Cargo Space",
  seats: "Seats",
  created_at: "Created At",
  updated_at: "Updated At",
  id: "ID",
  user_id: "User ID",
  invoices: "Invoices",
  vehicle: "My Vehicles",
  transfer_all: "All Trips Overview",
  transfer_new: "New Trips",
  transfer_assign: "Assign driver",
  vatIdLabel: "Customer VAT ID",
  bookingAs: "I am booking as",
  privatePerson: "Private person",
  companyOption: "Company",
  companyName: "Company name",
  vatIdOptional: "VAT ID (optional)",
  vatIdInvalid: "Invalid VAT ID (e.g. DE123456789)",
  receiptHint: "For the receipt/invoice",
  transfer_close: "To complete",
  completeTrip: "Complete",
  completeTripConfirm: "Complete this trip? The customer receives the thank-you email and the receipt; the payment is marked as paid.",
  instantConfirmed: "Instant confirmation",
  ratingFilter: "Rating",
  allRatings: "All ratings",
  starsAndUp: "stars and up",
  instantHint: "Instant confirmation: your booking is confirmed right away",
  transfer_today: "Today's Trips",
  transfer_tomorrow: "Tomorrow's Trips",
  transfer_current: "Ongoing Trips",
  transfer_storno: "Cancelled Trips",
  transfer_reklamiert: "Complained Trips",
  transfer_noshow: "No-Show Trips",
  transfer_finished: "Completed Trips",
  transfer_all_admin: "All Trips Overview",
  transfer_new_admin: "New Trips",
  transfer_today_admin: "Today's Trips",
  transfer_tomorrow_admin: "Tomorrow's Trips",
  transfer_current_admin: "Ongoing Trips",
  transfer_storno_admin: "Cancelled Trips",
  transfer_reklamiert_admin: "Complained Trips",
  transfer_noshow_admin: "No-Show Trips",
  transfer_finished_admin: "Completed Trips",
  driver: "My Drivers",
  first_name: "First Name",
  last_name: "Last Name",
  pickup_datetime: "Pickup Date / Pickup Time",
  status: "Status",
  total_price: "Total Price",
  route: "From → To",
  payment_method: "Payment Method",
  currency: "Currency",
  invoice_status: "Invoice",
  data: "My Company",
  company_active: "User Activated",
  logo: "Company Logo Upload",
  company_name: "Company Name",
  company_legal_form: "Legal Form",
  company_register_number: "Trade Register Number",
  company_street: "Address",
  company_zip: "ZIP",
  company_country: "Country",
  company_city: "City",
  company_tax_number: "Tax ID",
  company_vat_id: "VAT ID",
  company_phone: "Phone Number (Business)",
  company_email: "Email Address (Business)",
  company_website: "Website/Homepage",
  licence: "Business License Upload",
  company_licence: "Business License Available?",
  company_licence_expiration: "Business License Expiration Date?",
  prices: "Tiered Prices",
  bis10km: "Calculated Price per KM up to 10KM",
  bis20km: "Calculated Price per KM up to 20KM",
  bis50km: "Calculated Price per KM up to 50KM",
  bis100km: "Calculated Price per KM up to 100KM",
  ab100km: "Calculated Price per KM from 100KM",
  citys: "Cities Served",
  getpartner: "Become a Partner",
  partnerlogin: "Partner Login",
  editbooking: "Manage Booking",
  contact: "Contact",
  booknow: "Book Now",
  oneway: "One Way Only",
  roundtrip: "Round Trip",
  flughafentransfer: "Airport Transfer",
  ConvenientAndOnTime: "On Time. Convenient.",
  yourTransfer: "Your Transfer.",
  bnHeadline: "Where would you like to go today?",
  bnSub: "Your airport transfer at a fixed price – booked in a few clicks",
  bnPopular: "Popular routes",
  bnRoute1: "Cologne → Düsseldorf Airport",
  bnRoute2: "Essen → Düsseldorf Airport",
  bnRoute3: "Düsseldorf → Cologne/Bonn Airport",
  bnRoute4: "Bonn → Frankfurt Airport",
  moBestRated: "Best rated",
  moRecommended: "Recommended",
  moAll: "All",
  moDetails: "Details",
  moLess: "Less",
  moOffersN: "{n} offers",
  moOfferOne: "1 offer",
  moFrom: "from",
  moPicksTitle: "Our picks for you",
  moCheapest: "Cheapest",
  guideHello: "Hello, where to?",
  guideTitle1: "Your transfer",
  guideTitle2: "in 3 steps",
  guideStepRoute: "Route",
  guideStepDate: "Date",
  guideStepOffer: "Offer",
  guideRoute: "Your route",
  guideWhen: "When?",
  guideToday: "Today",
  guideTomorrow: "Tomorrow",
  guidePick: "Date",
  guidePickupTime: "Pickup time",
  guideReturn: "Add return trip",
  uberHeadline: "Your transfer – anywhere you go",
  privateTransferDescription: "Private chauffeur service at fixed prices – door to door, no surprises.",
  bookRide: "Book Ride",
  destination: "Destination",
  enterDestinationAddress: "Enter destination address",
  returnTrip: "Return Trip",
  outboundTrip: "Outbound Trip",
  paymentMethods: "Payment Methods",
  loading: "Loading…",
  showOffers: "Show Offers",
  rides: "Rides",
  customerRating: "Customer Rating",
  vehicles: "Vehicles",
  support: "Support",
  recentSearches: "Recent Searches",
  departure: "Departure",
  enterStartAddress: "Enter starting address",
  swapAddresses: "Swap Addresses",
  whyGoTransfer24: "Why GoTransfer24",
  clearBenefits: "Clear Benefits",
  atAGlance: "at a glance.",
  fairFixedPricesTitle: "Fair Fixed Prices",
  fairFixedPricesDescription: "No meter, no risk. The price is fixed before booking – transparent and guaranteed.",
  bookedIn60SecondsTitle: "Booked in 60 Seconds",
  bookedIn60SecondsDescription: "Start, destination, vehicle – done. No registration, no paperwork, no waiting.",
  flexiblePaymentTitle: "Flexible Payment",
  flexiblePaymentDescription: "PayPal, credit card, or cash to the driver. You decide what suits you best.",
  verifiedDriversTitle: "Verified Drivers",
  verifiedDriversDescription: "All drivers are licensed and personally verified. Punctuality and professionalism guaranteed.",
  available247Title: "Available 24/7",
  available247Description: "Early flight at 4 AM? No problem. We're here for you around the clock.",
  luggageExtrasTitle: "Luggage & Extras",
  luggageExtrasDescription: "Child seat, extra luggage, pets – all bookable. Just add them at checkout.",
  chooseRoute: "Choose Route",
  selectTripType: "Select one-way or round trip",
  enterAddresses: "Enter start and destination address",
  setDateTime: "Set Date & Time",
  chooseVehicle: "Choose Vehicle",
  compareOffersPrices: "Compare Offers and Prices",
  selectVehicle: "Select Suitable Vehicle",
  enterDetails: "Enter Details",
  enterPassengerDetails: "Enter Passenger Details",
  addFlightInformation: "Add Flight Information",
  selectExtras: "Select Extras & Additional Services",
  confirmation: "Confirmation",
  selectPaymentMethod: "Select Payment Method",
  receiveBookingConfirmation: "Receive Booking Confirmation",
  businessAirportTransfer: "Business Airport Transfer",
  economyAirportTransfer: "Economy Airport Transfer",
  luxuryAirportTransfer: "Luxury Airport Transfer",
  vipSprinterTransfer: "VIP Sprinter Transfer",
  faqPriceQuestion: "What does an airport transfer with GoTransfer24 cost?",
  faqPriceAnswer: "The price depends on the route, date and selected vehicle class and is shown as a fixed price before you complete your booking. No extra costs for traffic, night trips or normal luggage.",
  faqAdvanceBookingQuestion: "How far in advance should I book?",
  faqAdvanceBookingAnswer: "Bookings are possible even at short notice, but we recommend at least 24 hours in advance – especially during high demand periods such as holidays or peak travel season.",
  faqFlightDelayQuestion: "What happens if my flight is delayed?",
  faqFlightDelayAnswer: "No problem – the arrival time is tracked live and adjusted automatically. Your driver is informed of the delay and will wait accordingly, with no extra charges.",
  faqCancelChangeQuestion: "Can I cancel or change my booking?",
  faqCancelChangeAnswer: "Yes, changes and cancellations are free of charge up to 24 hours before the scheduled pickup.",
  faqChildSeatsQuestion: "Do you offer child seats and accessible vehicles?",
  faqChildSeatsAnswer: "Yes, child seats for various age groups can be added during booking, and our van class is also wheelchair-accessible at many locations.",
  faqPaymentQuestion: "Which payment methods are accepted?",
  faqPaymentAnswer: "Online you can pay by card, PayPal, Klarna, invoice, or installments. On-site payment directly to the driver is also possible.",
  transferServiceDescription: "GoTransfer24 connects you with verified drivers for private airport transfers throughout Germany and Europe. Whether it's a business trip, family vacation or city break – we get you reliably and directly to the airport or straight to your door. Fixed prices, automatic flight monitoring for delays, and booking in under a minute make the transfer as simple as possible.",
  routePriceCologneDusseldorf: "from €99",
  routePriceFrankfurtHeidelberg: "from €129",
  routePriceMunichAugsburg: "from €89",
  routePriceHamburgLuebeck: "from €79",
  routePriceBerlinPotsdam: "from €69",
  routePriceStuttgartUlm: "from €109",
  popularRoutes: "Popular Routes",
  allLocations: "All Locations",
  chooseYour: "Choose Your",
  airport_: "Airport.",
  allLocationsOverview: "All Locations Overview",
  locationsDescription: "GoTransfer24 connects you with verified partner drivers at 26 locations in 11 countries. Each city has its own page with local routes, terminal info and questions specific to that airport.",
  priceDisclaimer: "* Price, duration and distance are approximate and do not constitute a binding offer.",
  somethingWentWrong: "Something went wrong. Please try again.",
  sustainability: "Sustainability",
  everyRide: "Every Ride",
  aTree: "a tree.",
  treePlantingDescription: "For every online and WhatsApp booking, we plant a tree. As an environmentally conscious company, we want to not only promote sustainable mobility but also actively contribute to environmental protection. Thank you for your support.",
  treesPlanted: "Trees Planted",
  compensated: "Offset",
  howItWorks: "How It Works",
  inFourSteps: "In 4 Steps",
  toBooking: "to your booking.",
  ourStrengths: "Our Strengths",
  clearAdvantagesWith: "Clear Advantages with",
  freeNonBindingService: "Free, non-binding service",
  punctualPickupsGuaranteed: "Punctual pickups guaranteed",
  verifiedDriverNetwork: "Verified driver network",
  upTo70PercentCheaperThanTaxis: "Up to 70% cheaper than taxis",
  topRatingsSatisfiedCustomers: "Top ratings from satisfied customers",
  customerReviews: "Customer Reviews",
  whatOurCustomers: "What our customers",
  say: "say.",
  reviewMarco: "Super punctual, clean vehicle and a friendly driver. I'll book again.",
  reviewLena: "Easy to book and much cheaper than a taxi. Perfect for the airport!",
  reviewThomas: "Professional service from the first click to arrival. Highly recommended.",
  supportDescription: "If you have questions, suggestions or comments, our qualified support team is happy to help.",
  germany: "Germany",
  netherlands: "Netherlands",
  belgium: "Belgium",
  france: "France",
  luxembourg: "Luxembourg",
  switzerland: "Switzerland",
  austria: "Austria",
  czechia: "Czechia",
  poland: "Poland",
  denmark: "Denmark",
  turkey: "Turkey",
  cologne: "Cologne",
  dusseldorf: "Dusseldorf",
  frankfurt: "Frankfurt",
  munich: "Munich",
  berlin: "Berlin",
  hamburg: "Hamburg",
  stuttgart: "Stuttgart",
  hannover: "Hanover",
  amsterdam: "Amsterdam",
  eindhoven: "Eindhoven",
  brussels: "Brussels",
  charleroi: "Charleroi",
  paris: "Paris",
  luxembourgCity: "Luxembourg",
  zurich: "Zurich",
  geneva: "Geneva",
  basel: "Basel",
  vienna: "Vienna",
  prague: "Prague",
  warsaw: "Warsaw",
  copenhagen: "Copenhagen",
  istanbul: "Istanbul",
  antalya: "Antalya",
  bodrum: "Bodrum",
  izmir: "Izmir",
  ankara: "Ankara",
  priceCologneDusseldorf: "from €99",
  priceFrankfurtHeidelberg: "from €79",
  priceMunichAugsburg: "from €149",
  priceHamburgLuebeck: "from €149",
  allQuestions: "All Questions",
  viewAnswers: "View Answers",
  frequentlyAskedQuestions: "Frequently Asked Questions",
  questionsAbout: "Questions about",
  airportTransfer: "Airport Transfer",
  travelKnowledge: "Travel Knowledge",
  guide: "Guide",
  our: "Our",
  tipsInsightsNewsDescription: "Tips, insights and news about airport transfers, travel and mobility.",
  viewAllGuideArticles: "View All Guide Articles",
  haveAQuestion: "Have a Question?",
  travelTips: "Travel Tips",
  business: "Business",
  family: "Family",
  stressFreeAirportTransferTitle: "The 7 Best Tips for a Stress-Free Airport Transfer",
  stressFreeAirportTransferDescription: "How to plan your trip to the airport as relaxed as possible – from the right buffer time to choosing the right vehicle class.",
  businessTravelTitle: "Business Travel: How to Get to Your Important Meeting Relaxed",
  businessTravelDescription: "There's often little time between the flight and the appointment. We show you how the right planning gets you there punctual and rested.",
  familyVacationTitle: "Family Vacation: Getting to the Airport Safely with Kids",
  familyVacationDescription: "Child seats, luggage and tired kids – we give practical tips for keeping the trip to the airport relaxed for the whole family.",
  june12_2026: "June 12, 2026",
  may28_2026: "May 28, 2026",
  may15_2026: "May 15, 2026",
  readTime4Minutes: "4 min read",
  readTime3Minutes: "3 min read",
  readTime5Minutes: "5 min read",
  roundTripShort: "Round Trip",
  editSearch: "Edit Search",
  edit: "Edit",
  startNewSearch: "Start New Search",
  cancel: "Cancel",
  search: "Search",
  dateRequired: "Date required",
  timeRequired: "Time required",
  returnDateRequired: "Return date required",
  returnTimeRequired: "Return time required",
  vehicleCategory: "Vehicle Category",
  reset: "Reset",
  categoryTaxi: "Taxi",
  categoryEconomy: "Economy",
  categoryBusiness: "Business",
  categoryMinibus: "Minibus",
  categoryMinibusWheelchair: "Minibus Wheelchair",
  categoryGoGreen: "GoGreen",
  categoryFirstClass: "First Class",
  categoryKomfort: "Comfort",
  categoryLuxury: "Luxury",
  filterTitle: "Filter",
  passengers: "Passengers",
  vehiclesForAtLeast: "Vehicles for ≥",
  people: "People",
  luggage: "Luggage",
  luggagePieces: "Pieces of Luggage",
  wheelchair: "Wheelchair",
  allVehicles: "All Vehicles",
  wheelchairSeats: "Wheelchair Seats",
  noRatingsYet: "No ratings yet",
  orSimilar: "or similar",
  upTo: "up to",
  handLuggage: "Hand Luggage",
  childSeatGroup1Name: "Child Seat Group 1",
  childSeatGroup1Desc: "(Approx. from 1 to 4 years), 9 to 18 kg",
  childSeatGroup23Name: "Child Seat Group 2/3",
  childSeatGroup23Desc: "(Approx. from 5 to 12 years), 18 to 38 kg",
  babySeatName: "Infant Car Seat",
  babySeatDesc: "For babies up to 12 months. +1 kg – 9 kg",
  luggageHelpName: "Luggage Assistance",
  luggageHelpDesc: "The driver helps with your luggage",
  meetGreetName: "Meet & Greet",
  meetGreetDesc: "The driver greets you with a name sign and helps with luggage.",
  privateRide: "Private Ride",
  support247: "24/7 Support",
  freeCancellation: "Free cancellation up to 24h before the trip",
  provider: "Provider",
  bookNow: "Book Now",
  showLess: "Show Less",
  moreOffers: "more offers",
  priceFrom: "Price from",
  book: "Book",
  loadingOffers: "Loading offers …",
  noOfferIdFound: "No offer ID found",
  errorLoadingOffers: "Error loading offers",
  unknownError: "Unknown error",
  offersFound: "offers found",
  cheapest: "↑ Cheapest",
  mostExpensive: "↓ Most Expensive",
  noVehiclesFound: "No vehicles found for the selected filters.",
  resetFilters: "Reset Filters",
  taxi_limousine: "Taxi Sedan",
  taxi_kombi: "Taxi Estate",
  taxi_van: "Taxi Van",
  economy_limousine: "Economy Sedan",
  economy_kombi: "Economy Estate",
  economy_minivan: "Economy Minivan",
  economy_van: "Economy Van",
  business_kombi: "Business Estate",
  business_van: "Business Van",
  minibus: "Minibus",
  business_limousine: "Business Sedan",
  minibus_wheelchair: "Minibus Wheelchair",
  gogreen: "GoGreen",
  firstclass: "First Class",
  komfort: "Comfort",
  luxury: "Luxury",
  oclock: "o'clock",
  vehicleSection: "Vehicle",
  max: "Max",
  included: "Included",
  freeCancelShort: "Free Cancellation",
  serviceProviderLabel: "Service Provider",
  routeSection: "Route",
  priceOverview: "Price Overview",
  ride: "Ride",
  total: "Total",
  loadingData: "Loading …",
  noSessionIdFound: "No session ID found",
  dataLoadError: "Data could not be loaded.",
  less: "less",
  more: "more",
  free: "Free",
  next: "Next",
  saving: "Saving …",
  errorSavingExtras: "Error saving extras.",
  extraServicesTitle: "Additional Services",
  transferDetails: "Transfer Details",
  closeDetails: "Close Details",
  showDetails: "Show Details",
  closeShort: "↓ Close",
  detailsShort: "↑ Details",
  totalPrice: "Total Price",
  childSeatGroup1: "Child Seat Group 1",
  childSeatGroup1Description: "(Approx. from 1 to 4 years), 9 to 18 kg",
  childSeatGroup2_3: "Child Seat Group 2/3",
  childSeatGroup2_3Description: "(Approx. from 5 to 12 years), 18 to 38 kg",
  infantCarrier: "Infant Car Seat",
  infantCarrierDescription: "For babies up to 12 months. +1 kg – 9 kg",
  waterSnack: "Water & snack",
  waterSnackDescription: "A bottle of water and a small snack are waiting for you in the vehicle.",
  petTransport: "Pet transport",
  petTransportDescription: "Your pet rides along. Please bring a carrier or leash.",
  welcomeFlowers: "Flowers / welcome package",
  welcomeFlowersDescription: "A bouquet or welcome package for your guests in the vehicle – ideal for hotels and weddings.",
  powerBank: "Power bank / charging cable",
  powerBankDescription: "Charging cable and power bank in the vehicle so your phone arrives charged.",
  wifiHotspot: "Wi-Fi hotspot",
  wifiHotspotDescription: "Stay online during the ride with a Wi-Fi hotspot in the vehicle.",
  priorityPickup: "Priority pick-up",
  priorityPickupDescription: "The driver waits right at the gate and helps with a luggage trolley – the fastest way to your vehicle.",
  luggageAssistance: "Luggage Assistance",
  luggageAssistanceDescription: "The driver helps with your luggage",
  meetAndGreet: "Meet & Greet",
  meetAndGreetDescription: "The driver greets you with a name sign and helps with luggage.",
  errorSavingData: "Error saving data.",
  fillRequiredFields: "Please fill in all required fields",
  fillAllRequiredFields: "Please fill in all required fields",
  requiredField: "Required field",
  invalidEmail: "Invalid email address",
  pleaseSelect: "please select",
  title: "Title",
  salutation: "Salutation",
  lastName: "Last Name",
  firstName: "First Name",
  mobileNumber: "Mobile Number",
  emailAddress: "Email Address",
  zipCode: "ZIP Code",
  city: "City",
  address: "Address",
  houseNumber: "House No.",
  flightNumber: "Flight Number",
  infoForDriver: "Information for the Driver",
  personalDataTitle: "Personal Data",
  personalDataDesc: "Information about you",
  contactTitle: "Contact",
  contactDesc: "Enter your contact details here so the provider can reach you with questions.",
  addressTitle: "Address",
  addressDesc: "Please provide your full address so it can be correctly stated on the invoice.",
  outboundFlightTitle: "Outbound Flight Details",
  returnFlightTitle: "Return Flight Details",
  flightDataDesc: "Please provide your complete flight details so we can plan your transfer optimally.",
  mr: "Mr.",
  mrs: "Mrs.",
  diverse: "Diverse",
  reviewAndPayTitle: "Review Details & Payment",
  choosePaymentMethod: "Choose Payment Method",
  comingSoon: "Coming Soon",
  cashLabel: "Cash Payment",
  cashDesc: "Payment directly to the driver – booking is confirmed immediately",
  cardOnTripLabel: "Card Payment to Driver",
  cardOnTripDesc: "Pay by card on-site on the day of the transfer",
  stripeLabel: "Credit / Debit Card",
  stripeDesc: "Visa, Mastercard, Amex, Apple Pay, Google Pay – instant confirmation",
  customOfferLabel: "Make an Offer",
  customOfferDesc: "Suggest your own price – provider reviews and confirms",
  yourOfferLabel: "Your Price Suggestion",
  offerHint: "⏳ Must be confirmed by the provider – you'll then receive a payment link via email.",
  offerInfoBanner: "Your price suggestion will be forwarded to the provider. They must first confirm your offer. After confirmation, you'll receive an individual payment link via email.",
  invoiceLabel: "On Invoice",
  invoiceDesc: "Payment after receiving the invoice",
  installmentLabel: "Installments",
  installmentDesc: "Pay in convenient installments",
  couponTitle: "Coupon Code",
  couponPlaceholder: "Enter code …",
  redeem: "Redeem",
  couponInvalid: "This coupon is invalid.",
  couponSuccess: "✓ Coupon redeemed!",
  bookingOverviewTitle: "Booking Overview",
  reviewYourDataDesc: "Review your details",
  contactShortDesc: "Your contact details",
  emailShort: "Email",
  billingAddressDesc: "Billing address",
  zipShort: "ZIP",
  outboundFlightDesc: "Outbound flight details",
  returnFlightDesc: "Return flight details",
  checkoutLabel: "Checkout",
  sumLabel: "Subtotal",
  regularPrice: "Regular Price",
  vatNote: "* incl. VAT",
  shareLink: "Share Link",
  scanQrCode: "Scan QR Code",
  qrCodeAlt: "QR code for this page",
  copyLink: "Copy Link",
  linkCopied: "✓ Link copied!",
  agbTextBefore: "I have read the",
  agbLinkLabel: "Terms and Conditions",
  agbTextAfter: "and accept them. *",
  newsletterOptinLabel: "Yes, I would like to receive the newsletter and not miss any offers.",
  agbRequiredHint: "* Please accept the terms and conditions to continue.",
  sendingOffer: "Sending offer …",
  redirecting: "Redirecting …",
  submitOffer: "Submit Offer",
  payNow: "Pay Now",
  bookingSubmitError: "Error submitting the booking.",
  stripeSecureNote: "Secure payment – Powered by Stripe",
  cashNote: "Cash payment directly to the driver",
  offerPendingNote: "Provider confirms & sends payment link",
  completePaymentLabel: "Complete Payment",
  footerCompanyDescription: "We developed our service to offer you reliable, high-quality airport transfers anytime, anywhere – without any hassle.",
  footerLinksTitle: "Links",
  aboutUs: "About Us",
  bookTransfer: "Book Transfer",
  footerServiceTitle: "Service",
  vehicleFleet: "Vehicle Fleet",
  faq: "FAQ",
  footerLegalTitle: "Legal",
  imprint: "Imprint",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms & Conditions",
  newsletterTitle: "Newsletter",
  newsletterDescription: "Latest news and updates straight to your inbox.",
  emailPlaceholder: "Your email address",
  sending: "Sending…",
  subscribe: "Subscribe",
  newsletterEmailRequired: "Please enter an email address.",
  newsletterEmailInvalid: "Please enter a valid email address.",
  newsletterSuccess: "Thank you! You have successfully subscribed.",
  newsletterError: "Subscription failed. Please try again.",
  allRightsReserved: "All rights reserved.",
  affiliateProgram: "Affiliate Program",
  affiliateHeroTitle: "Become part of",
  affiliateHeroAccent: "GoTransfer24.",
  affiliateHeroSub: "Refer us via social media, your website or your company and earn on every successfully referred ride.",
  becomeAffiliateCta: "Become an Affiliate",
  whyPartnerWithUs: "Why Partner With Us?",
  affiliateBenefitsTitleLine1: "What you get",
  affiliateBenefitsTitleLine2: "as a partner.",
  affiliateBenefit1: "Individual commission on every referred booking",
  affiliateBenefit2: "Your own tracking link for easy attribution",
  affiliateBenefit3: "Monthly payout, full transparency",
  affiliateBenefit4: "No minimum revenue, no hidden costs",
  affiliateCommissionTitle: "How is the commission calculated?",
  affiliateCommissionExplanationText: "The commission is calculated individually and depends on reach, target audience and expected referral volume. Depending on your partner profile, it typically ranges between 5% and 15% per successfully referred booking. After your application, you'll receive a personal offer with your specific rate.",
  affiliateCommissionDisclaimer: "The commission is calculated individually and communicated after review of your application.",
  affiliateStepsTitle: "3 Steps to Becoming a Partner",
  affiliateStep1Title: "Apply",
  affiliateStep1Desc: "Fill out the form and state your reach.",
  affiliateStep2Title: "Review & Offer",
  affiliateStep2Desc: "We review your profile and send you your individual rate.",
  affiliateStep3Title: "Refer & Earn",
  affiliateStep3Desc: "Share your link and receive commission on every booking.",
  affiliateFinalCtaTitle: "Ready to grow with us?",
  affiliateMetaTitle: "Affiliate & Partner Program",
  affiliateMetaDescription: "Become a GoTransfer24 affiliate partner and earn an individually calculated commission on every referred airport transfer booking.",
  becomeAffiliateTitle: "Become an Affiliate",
  becomeAffiliateIntro: "Fill out the form – we'll get back to you with an individual offer.",
  firstNameRequiredError: "Please enter first name",
  lastNameRequiredError: "Please enter last name",
  emailRequiredError: "Please enter email address",
  emailInvalidError: "Please enter a valid email address",
  atLeastOneOfTheFollowing: "Fill in at least one of the following fields:",
  atLeastOneSocialRequiredError: "Please provide at least one social media account or a company",
  companyOptional: "Company (optional)",
  companyNamePlaceholder: "Company name",
  submitApplication: "Submit Application",
  affiliateApplicationReceivedTitle: "Application Received!",
  affiliateApplicationReceivedText: "Thank you for your interest. We will review your details and get back to you with your individual commission offer.",
  close: "Close",
  successTitleOffer: "Offer Received!",
  successTitleConfirmed: "Booking Confirmed!",
  emailFallback: "Your email address",
  thankYouLabel: "Thank you",
  offerSubtitlePart1: "! Your price suggestion of",
  offerSubtitlePart2: "has been forwarded to the provider. After review you will receive an individual payment link at",
  cashSubtitlePart1: "! Your booking is confirmed. Please pay the amount directly to the driver. A confirmation will be sent to",
  defaultSubtitlePart1: "! Your payment was processed successfully. A booking confirmation will be sent to",
  bookingNumberLabel: "Booking Number",
  paymentTypeLabel: "Payment Type",
  creditCardLabel: "Credit Card",
  offerPaymentTypeLabel: "Offer",
  statusLabel: "Status",
  statusPendingProviderCheck: "Pending – Provider is reviewing",
  statusConfirmed: "Confirmed",
  redirectingToOverviewPart1: "You will be redirected to the booking overview in",
  secondsLabel: "second",
  redirectingToOverviewPart3: "…",
  redirectFailedText: "Automatic redirect failed.",
  goToBookingOverview: "Go to Booking Overview →",
  backToHomeLabel: "Back to Home",
  cookieSettings: "Cookie Settings",
  logout: "Log Out",
  language: "Language",
  ourtransfers: "My Trips",
  profiledescription: "All transfer bookings assigned to you",
  rows: "Records",
  filtered: "filtered",
  searchPlaceholder: "Search",
  pagingOf: "of",
  searchLabel: "Search",
  resetFilter: "reset",
  selectedCount: "selected",
  clearSelection: "clear",
  menuOpen: "Open menu",
  menuClose: "Close menu",
  flightScheduled: "Scheduled",
  flightActive: "In Flight",
  flightLanded: "Landed",
  flightCancelled: "Cancelled",
  flightDiverted: "Diverted",
  flightIncident: "Incident",
  flightRedirected: "Diverted",
  flightPrefix: "Flight",
  flightLoading: "Loading flight data …",
  flightNotFound: "No flight data available for",
  flightCheckNote: "Please check the flight number in the note.",
  flightDeparture: "Departure",
  flightArrival: "Arrival",
  flightPlanned: "Scheduled",
  flightDelay: "Delay",
  flightDelayDep: "min departure",
  flightDelayArr: "min arrival",
  flightBaggage: "Baggage Claim",
  flightBaggageBand: "Belt",
  flightAirline: "Airline",
  chatWithCustomer: "Chat with Customer",
  chatBooking: "Booking",
  chatLoading: "Loading messages …",
  chatEmpty: "No messages yet. Write a message to the customer.",
  chatInputPlaceholder: "Write a message …",
  chatDisabled: "Chat is disabled for past/future trips",
  chatOnlyToday: "Chat only available on the day of the trip",
  chatClose: "Close Chat",
  chatOpenLabel: "Open Chat",
  chatButtonLabel: "Chat",
  chatLoadError: "Error loading messages",
  chatSendFail: "Message could not be sent",
  chatSendError: "Error sending message",
  salutationMr: "Mr.",
  salutationMrs: "Mrs.",
  tripReturn: "Round Trip",
  tripOneway: "One-Way Trip",
  noTripsAvailable: "No trips available.",
  noTripsSearch: "No results for the current search",
  noTrips: "No trips available",
  pickupTag: "Pickup",
  destinationTag: "Destination",
  paymentLabel: "Payment",
  passengersLabel: "Passengers",
  customerLabel: "Customer",
  phoneLabel: "Phone Number",
  extrasLabel: "Extras",
  noteLabel: "Note",
  flightInfoLabel: "Flight Info",
  yourSharePrefix: "Your share (outbound)",
  cancelBtn: "Cancel",
  counterOfferBtn: "Counter Offer",
  waitingCustomerResponse: "Waiting for customer response",
  newBadge: "New",
  enrouteBtn: "En Route",
  onboardBtn: "Picked Up",
  noshowBtn: "No Show",
  completeBtn: "Complete",
  cancelledBadge: "Cancelled",
  completedBadge: "Completed",
  noshowDoneBadge: "No Show",
  complainedBadge: "Complained",
  cancelTripTitle: "Cancel Trip?",
  cancelBookingPrefix: "Booking",
  cancelIrreversible: "This action cannot be undone.",
  cancelNotifyText: "The trip will be cancelled and the customer will be notified.",
  fromLabel: "From",
  toLabel: "To",
  dateLabel: "Date",
  abortBtn: "Cancel",
  confirmCancelBtn: "Yes, cancel now",
  tripCancelledToast: "has been cancelled",
  cancelErrorToast: "Error cancelling",
  statusEnrouteLabel: "Start En Route",
  statusEnrouteDesc: "You are now starting the trip to the customer.",
  statusOnboardLabel: "Passenger Picked Up",
  statusOnboardDesc: "You confirm that you have picked up the passenger.",
  statusCompletedLabel: "Complete Trip",
  statusCompletedDesc: "You mark this trip as completed.",
  confirmBtn: "Confirm",
  statusUpdateError: "Error updating",
  statusEnrouteToast: "En route started",
  statusOnboardToast: "Passenger picked up",
  statusCompletedToast: "Trip completed",
  counterOfferTitle: "Make Counter Offer",
  originalPriceLabel: "Original Price",
  customerOfferLabel: "Customer Offer",
  yourCounterOfferLabel: "Your Counter Offer",
  counterOfferInvalid: "Please enter a valid amount.",
  counterOfferSaveError: "Error saving. Please try again.",
  counterOfferNotifyInfo: "The customer will receive a notification after saving.",
  counterOfferSaving: "Saving …",
  counterOfferSendBtn: "Send Counter Offer",
  counterOfferSavedToast: "Counter offer for",
  counterOfferSavedToastSuffix: "saved",
  vehicleDialogTitle: "Select Vehicle",
  vehicleLoading: "Loading vehicles …",
  vehicleLoadError: "Vehicles could not be loaded.",
  vehicleLoadErrorGeneric: "Error loading vehicles.",
  vehicleNoneAvailable: "No vehicles available.",
  vehicleStarting: "Starting …",
  vehicleStartBtn: "Start En Route",
  vehiclePleaseChoose: "Please select a vehicle",
  vehicleSaveError: "Error saving.",
  vehicleStartError: "Error starting the trip.",
  vehicleStartedToast: "En route started",
  vehicleFallbackName: "Vehicle",
  noshowDialogTitle: "Report No Show",
  noshowInstructions: "Please take a photo of the pickup location clearly showing your vehicle. The location will be recorded automatically.",
  noshowMaxSizeSuffix: "Max.",
  currentLocationLabel: "Current Location",
  locationLoading: "Determining location …",
  locationReload: "Reload",
  locationRetry: "Try Again",
  locationUnavailable: "Location unavailable",
  geoNotSupported: "Geolocation is not supported by this device.",
  geoDenied: "Could not determine location. Please allow access.",
  photoOfPickupLabel: "Photo of Pickup Location",
  photoTakeLabel: "Take Photo",
  photoHint: "Open camera · Vehicle must be visible",
  photoChange: "Change",
  noshowNoteLabel: "Note",
  noshowNoteOptional: "(optional)",
  noshowNotePlaceholder: "e.g. doorbell not reachable, no answer on call …",
  noshowMissingPhoto: "Please take a photo of the pickup location.",
  noshowLocationPending: "Location is still being determined. Please wait a moment.",
  noshowPhotoTooLargePrefix: "The photo is too large",
  noshowPhotoTooLargeMax: "Maximum",
  noshowPhotoTooLargeHint: "Please take a smaller photo or reduce the camera quality.",
  noshowPhotoTooLargeHintShort: "Please take a smaller photo.",
  noshowGenericSaveError: "Error saving. Please try again.",
  noshowSubmitError: "Error submitting. Please try again.",
  noshowSubmitting: "Submitting …",
  noshowConfirmBtn: "Confirm No Show",
  noshowReportedToast: "No show reported for",
  pickupLabel: "Pickup Location",
  current: "Current",
  trips: "Trips",
  myData: "My Data",
  documents: "Documents",
  other: "Other",
  vehicle_class: "My Vehicles",
  company: "My Company",
  cities: "Cities",
  wallet: "Wallet",
  receipts: "Receipts",
  terms: "Terms & Conditions",
  privacy: "Privacy Policy",
  new: "New",
  overview: "Overview",
  income: "Income",
  expenses: "Expenses",
  welcomeBack: "Welcome Back",
  dashboardErrorTitle: "Something went wrong",
  dashboardErrorText: "Data could not be loaded.",
  noWidgetsTitle: "No Widgets Configured",
  noWidgetsText: "There are currently no overview tiles available.",
  completed: "Completed",
  upcoming: "Upcoming",
  cancelled: "Cancelled",
  noShow: "No Show",
  complained: "Complained",
  tomorrow: "Tomorrow",
  thisWeek: "This Week",
  count: "Count",
  ofWhichNoShow: "Of which No Show",
  ofWhichComplained: "Of which complained",
  transfer_total: "Total",
  transfer_done: "Completed",
  transfer_open: "Upcoming",
  transfer_week: "This Week",
  transfer_storno_reklamiert: "Of which complained",

  newTrips: "New Trips",
  notransferdatafound: "No trips available.",
  noResultsForFilters: "No results for the current filters",
  returnTripOn: "Return trip on",

  generateInvoice: "Generate Invoice",
  details: "Details",
  accept: "Accept",
  changeDriver: "Change Driver",
  assignDriver: "Assign Driver",
  cancelList: "Cancel",

  counterOffer: "Counter Offer",
  acceptOffer: "Accept Offer",
  waitingForCustomerResponse: "Waiting for customer response",
  waitingForCustomerPayment: "Waiting for customer payment",
  accepted: "Accepted",

  pleaseAssignDriver: "Please assign a driver",
  driverOnTheWay: "Driver on the way",

  customerOnBoard: "Customer on board",

  acceptOfferQuestion: "Accept offer?",
  bookingPrefix: "Booking",

  confirmCustomerOffer: "Confirm Customer Offer",
  customerOfferPaymentInfo: "The customer will be notified by email and redirected to payment. The booking will be confirmed automatically after payment.",

  offerPrice: "Offer Price",

  yesAcceptOffer: "Yes, accept offer",

  selectDriver: "Select Driver",
  loadingDrivers: "Loading drivers …",
  noDriversAvailable: "No drivers available.",

  confirmTrip: "Confirm Trip",
  pleaseSelectDriver: "Please select a driver",

  cancelTripQuestion: "Cancel trip?",
  cancelNotifyCustomer: "The trip will be cancelled and the customer will be notified.",

  from: "From",
  to: "To",

  confirmCancel: "Yes, cancel now",

  create: "Create",

  makeCounterOffer: "Make Counter Offer",
  originalPrice: "Original Price",
  customerOffer: "Customer Offer",
  yourCounterOffer: "Your Counter Offer",
  counterOfferNotify: "The customer will receive a notification after saving.",
  sendCounterOffer: "Send Counter Offer",
  // StepDialog (New Record)
  newRecordTitle: "Create New Record",
  stepLabel: "Step",
  ofLabel: "of",
  enterValuePlaceholder: "enter...",
  yes: "Yes",
  no: "No",

  // MatchDialog
  selectMatch: "Make Selection",

  // ConfirmDialog
  affectedRecords: "Affected Records:",

  // FilterDialog
  applyFilterTitle: "Apply Filter",
  applyFilterSubtitle: "Filter records by criteria",
  active: "Active",
  inactive: "Inactive",
  noFilterableFields: "No filterable fields available",
  applyFilterButton: "✓ Apply Filter",

  // AdminEditDialog
  editRecordTitle: "Edit Record",
  bookingLabel: "Booking",
  noEditableFields: "No editable fields configured",
  savingEllipsis: "Saving …",
  saveButton: "✓ Save",
  adminEditTooltip: "Edit record (Admin)",

  // Footer / Paging
  filteredLabel: "(filtered)",
  recordsLabel: "Records",
  filterLabel: "Filter:",
  selectedLabel: "selected",
  clearLabel: "clear",

  // Trip-Type Fallbacks
  tripTypeReturn: "Round Trip",
  tripTypeOneway: "One-Way Trip",

  // Formatting
  driverFallbackPrefix: "Driver #",

  // Toasts
  toastOfferAccepted: "Offer for #{id} accepted – customer will be notified",
  toastInvoiceCreated: "Invoice for #{id} has been created",
  toastDriverChanged: "Driver changed",
  toastDriverConfirmed: "confirmed",
  toastTripUpdated: "Trip #{id} has been {label}",
  toastTripCancelled: "Trip #{id} has been cancelled",
  toastCounterOfferSaved: "Counter offer for #{id} saved",
  toastRecordUpdated: "Record #{id} has been updated",

  // Error Messages
  errorAcceptOffer: "Error accepting the offer",
  errorCreateInvoice: "Error creating the invoice",
  errorSaveTrip: "Error saving the trip.",
  errorChangeDriver: "Error changing the driver.",
  errorConfirmTrip: "Error confirming the trip.",
  errorCancelTrip: "Error cancelling",
  errorInvalidAmount: "Please enter a valid amount.",
  errorSaveRetry: "Error saving. Please try again.",
  errorLoadDriversFailed: "Drivers could not be loaded.",
  errorLoadDrivers: "Error loading drivers.",
  errorSaveDefault: "Error saving",
  discount: "Discount",
  couponAvailableNote: "Secure your discount coupon now!",
  copied: "Copied!",
  clickToCopy: "Click to copy",
  appDownloadBannerText: "GoTransfer24 App",
  appDownloadBannerCta: "Download",
  planned: "Planned",
  aktive_stat: "Active",
  done: "Completed",
  en_route: "Driver en route",
  onboard: "Customer on board",
  card: "Card Payment",
  cash: "Cash Payment",
  cardOnTrip: "Card Payment to Driver",
  cardontrip: "Card Payment to Driver",
  thisweek: "This Week",
  unpaid: "Payment Pending",
  paid: "Paid",
  paypalLabel: "PayPal",
  paypalDesc: "Pay securely with your PayPal account",
  paypalSecureNote: "You will be securely redirected to PayPal",
  redirectingPaypal: "Redirecting to PayPal …",
  paypalCancelledNote: "The PayPal payment was cancelled.",
  paypalFailedNote: "The PayPal payment could not be completed.",
  paypal: "paypal",
  actual: "Current",
  transfers: "Trips",
  mydata: "My Data",
  others: "Other",
  vehicleclass: "My Vehicles",
  impressum: "Imprint",
  agb: "Terms & Conditions",
  datenschutz: "Privacy Policy",
  booking: "Booking",
  transferTripLabel: "Transfer Trip",
  outboundReturnTrip: "Round Trip",
  onewayTrip: "One-Way Trip",
  departureLabel: "Departure",
  distanceLabel: "Distance",
  returnTripSection: "Return Trip",
  customerSection: "Customer",
  baggageLabel: "Baggage",
  emergencyContactLabel: "Emergency Contact",
  paymentSection: "Payment",
  basePriceLabel: "Base Price",
  offerPriceLabel: "Offer Price",
  counterOfferLabel: "Counter Offer",
  categoryLabel: "Category",
  paymentMethodLabel: "Payment Method",
  pricePerKmLabel: "Price/km",
  receiptLabel: "Receipt",
  createdLabel: "Created",
  notCreatedYetLabel: "Not created yet",
  noCounterOfferYet: "No counter offer submitted yet",
  priceAccepted: "Price accepted",
  noShowReportSection: "No-Show Report",
  reportedAtLabel: "Reported At",
  accuracyLabel: "Accuracy",
  locationLabel: "Location",
  openInGoogleMaps: "Open in Google Maps",
  driverNoteLabel: "Driver's Note",
  driverNoticeLabel: "Driver Notice",
  driverPhotoLabel: "Photo from Driver",
  noShowPhotoAlt: "No-show proof photo",
  extrasSection: "Extras / Additional Services",
  totalExtrasLabel: "Total Extras",
  notesSection: "Notes",
  customerNoteLabel: "Customer Note",
  shortNoteLabel: "Short Note",
  internalNoteLabel: "Internal Note",
  ratingSection: "Rating",
  bookingDetailsSection: "Booking Details",
  createdAtLabel: "Created At",
  updatedAtLabel: "Updated",
  bookingSourceLabel: "Booking Source",
  tripTypeLabel: "Trip Type",
  externalIdLabel: "External ID",
  canceledAtLabel: "Cancelled At",
  cancelReasonLabel: "Cancellation Reason:",
  paymentPendingLabel: "Payment Pending",
  paidLabel: "Paid",
  paymentFailedLabel: "Failed",
  sourceWebsite: "Website",
  sourceManual: "Manual",
  sourceApi: "API",
  // English (en.js)
  pleaseSelectImageFile: "Please select an image file.",
  fileTooLargeError: "File too large (max. 10 MB).",
  driverCreatedToast: "Driver has been created",
  driverCreateErrorFallback: "Error creating driver",
  deleteDriverTitle: "Delete Driver",
  deleteDriverConfirmPrefix: "Do you really want to delete",
  deleteDriverConfirmSuffix: "? This action cannot be undone.",
  driverDeletedToast: "Driver has been deleted",
  deleteErrorToast: "Error deleting",
  wasDeactivated: "was deactivated",
  wasActivated: "was activated",
  statusUpdateErrorToast: "Error updating status",
  licenseExpired: "Expired",
  licenseExpiresIn: "Expires in",
  daysAbbrev: "days",
  licenseValidUntil: "Valid until",
  activeLabel: "Active",
  inactiveLabel: "Inactive",
  detailsButton: "Details",
  deactivateButton: "Deactivate",
  activateButton: "Activate",
  deleteButton: "Delete",
  createDriverTitle: "Add New Driver",
  yesLabel: "Yes",
  noLabel: "No",
  enterPlaceholderSuffix: "enter…",
  enterPlaceholderSuffixNoDots: "enter...",
  profilePhotoLabel: "Profile Photo",
  optionalLabel: "optional",
  previewAlt: "Preview",
  changePhotoLabel: "Change Photo",
  uploadPhotoLabel: "Upload Photo",
  removePhotoLabel: "Remove Photo",
  photoOptionalHint: "Not required – the photo can also be added later in the profile.",
  cancelButton: "Cancel",
  creatingLabel: "Creating…",
  createButton: "Create",
  enabledLabel: "Enabled",
  disabledLabel: "Disabled",
  filterDriversDesc: "Filter drivers by criteria",
  resetButton: "Reset",
  filterButton: "Filter",
  newDriverButton: "New Driver",
  ofLabelLower: "of",
  driversLabel: "Drivers",
  searchColonLabel: "Search:",
  resetLowerButton: "reset",
  filterColonLabel: "Filter:",
  clearLowerButton: "clear",
  loadingAriaLabel: "Loading…",
  // English (en.js)
  driverSavedToast: "Driver has been saved",
  saveErrorToast: "Error saving",
  imageProcessingError: "Error processing the image.",
  savingLabel: "Saving…",
  photoCardTitle: "Photo",
  photoSizeHint: "JPG/PNG, max. 10 MB · will be resized to 300×600 px",
  dataCardTitle: "Data",
  // English (en.js)
  licensePlateHint: "Format: 1–3 letters, 1–2 letters, 1–4 digits – e.g. M AB 1234",
  pricesLoadError: "Prices could not be loaded.",
  vehiclesLoadError: "Vehicles could not be loaded.",
  pleaseSelectBrandError: "Please select or enter a brand",
  pleaseSelectModelError: "Please select or enter a model",
  pleaseSelectColorError: "Please select or enter a color",
  pleaseEnterLicensePlateError: "Please enter a license plate",
  invalidFormatPrefix: "Invalid format –",
  vehicleAddedToast: "Vehicle has been added",
  vehicleAddErrorToast: "Error adding vehicle",
  vehicleDeletedToast: "Vehicle has been deleted",
  vehicleDeleteErrorToast: "Error deleting vehicle",
  vehicleActivatedToast: "Vehicle activated",
  vehicleDeactivatedToast: "Vehicle deactivated",
  statusChangeErrorToast: "Error changing status",
  pleaseSFillValidPricePrefix: "Please fill",
  pleaseSFillValidPriceSuffix: "with a valid price",
  pricesSavedToast: "Prices have been saved",
  pricesSaveErrorToast: "Error saving prices",
  vehicleCategoriesTitle: "Vehicle Categories",
  vehicleCategoriesDesc: "Manage tiered prices and vehicles directly per category.",
  vehiclesInThisClass: "Vehicles in this class",
  pricesSectionLabel: "Prices",
  tiersLabel: "Tiers",
  pricePerKmShort: "€ / km",
  minPriceLabel: "Minimum Price",
  savePricesButton: "Save Prices",
  vehiclesSectionLabel: "Vehicles",
  loadingVehiclesLabel: "Loading vehicles…",
  noVehiclesInClassLabel: "No vehicles in this class",
  brandLabel: "Brand",
  modelLabel: "Model",
  colorLabel: "Color",
  licensePlateLabel: "License Plate",
  addVehicleTitle: "Add Vehicle",
  selectBrandOption: "Select brand…",
  otherOption: "Other…",
  enterBrandPlaceholder: "Enter brand",
  selectModelOption: "Select model…",
  selectBrandFirstOption: "Select brand first",
  enterModelPlaceholder: "Enter model",
  selectColorOption: "Select color…",
  enterColorPlaceholder: "Enter color",
  licensePlateExamplePlaceholder: "e.g. M AB 1234",
  addVehicleButton: "Add Vehicle",
  deleteVehicleModalTitle: "Delete Vehicle?",
  thisVehicleLabel: "This vehicle",
  willBeRemovedFromCategoryPrefix: "will be permanently removed from the category",
  willBeRemovedFromCategorySuffix: ".",
  deletingLabel: "Deleting…",
  // English (en.js)
  fileTooLargeMaxAlert: "The file is too large. Maximum: 10MB",
  addressInputPlaceholder: "Enter address and select from the list...",
  previewSuffix: "Preview",
  uploadSuffix: "upload",
  removeButton: "Remove",
  photoUploadRecommendationHint: "Recommended: JPG/PNG, max. 10MB, will be automatically resized to 300x600px",
  addressRequiredFieldError: "Required field – please select an address from the list",
  noFieldGroupsDefined: "No field groups defined",
  fillAllRequiredAddressFieldsError: "Please fill in all required fields – for address fields, select a suggestion from the list.",
  readonlyLabel: "read-only",
  // English (en.js)
  selectAtLeastOneRecordError: "Please select at least one record.",
  selectOnlyOneRecordToEditError: "Please select only one record to edit.",
  noRecordsSelectedError: "No records selected.",
  actionExecutedSuccessSuffix: "executed successfully",
  noDataAvailableLabel: "No data available.",
  noRecordsAvailableLabel: "No records available",
  createNewRecordTitle: "Create New Record",
  makeSelectionTitle: "Make Selection",
  affectedRecordsLabel: "Affected Records:",
  idsLabel: "IDs",
  filterRecordsDesc: "Filter records by criteria",
  deselectAllLabel: "Deselect All",
  selectAllLabel: "Select All",
  clearSelectionLabel: "Clear Selection",
  sortedByLabel: "Sorted",
  filtersActiveLabel: "Filters active",
  // English (en.js)
  addButtonLabel: "Add",
  // English (en.js)
  periodAllLabel: "All",
  periodTodayLabel: "Today",
  periodWeekLabel: "Week",
  periodMonthLabel: "Month",
  periodYearLabel: "Year",
  transferLabel: "Bank Transfer",
  cashShortLabel: "Cash",
  cardShortLabel: "Card",
  canceledLabel: "Cancelled",
  balanceLoadError: "Balance could not be loaded.",
  noWalletDataFound: "No wallet data found.",
  partnerAccountLabel: "Partner Account",
  walletTitle: "Wallet",
  currentBalanceLabel: "Current Balance",
  noPayableBalanceTitle: "No Payable Balance",
  payoutButton: "Withdraw",
  transactionsLabel: "Transactions",
  searchBookingNumberPlaceholder: "Search booking number",
  noResultsForPrefix: "No results for",
  noTransactionsInPeriod: "No transactions in this period.",
  closeAriaLabel: "Close",
  payoutRequestedTitle: "Payout Requested",
  willBeTransferredSoonText: "will be transferred to the linked account shortly.",
  closeButton: "Close",
  confirmPayoutTitle: "Confirm Payout",
  amountTransferredToAccountText: "The amount will be transferred to the following account:",
  accountHolderLabel: "Account Holder",
  ibanLabel: "IBAN",
  bankLabel: "Bank",
  payoutAmountLabel: "Payout Amount",
  payoutTriggerErrorText: "Payout could not be triggered. Please try again.",
  requestingPayoutLabel: "Requesting…",
  payoutNowButton: "Withdraw Now",
  //LAST UPDATE 20082026
passengerCountTitle: "Number of passengers",
// Englisch
paymentCreditCardTitle: "Credit Card",
paymentCreditCardDescription: "Secure online payment right at booking.",
paymentPaypalTitle: "PayPal",
paymentPaypalDescription: "Pay conveniently via your PayPal account – pay later or in installments too.",
paymentCashTitle: "Cash",
paymentCashDescription: "Pay the fixed price in cash directly to the driver.",
paymentCardOnTripTitle: "Card in the vehicle",
paymentCardOnTripDescription: "Contactless card payment right in the car.",
paymentCustomOfferTitle: "Custom offer",
paymentCustomOfferDescription: "Suggest your own price, our partner confirms.",
paymentTagInstant: "Confirmed instantly",
paymentTagSSL: "SSL encrypted",
paymentTagInstallments: "Installments",
paymentTagPayLater: "Pay later",
paymentTagNoPrepay: "No prepayment",
paymentTagContactless: "Contactless",
paymentTagNegotiable: "Negotiable",
payHowItSuitsYou: "Pay however",
payHowItSuitsYouAccent: "suits you.",
// Englisch
roundTripSavingsNotice: "You save {percent}% when booking outbound and return together.",
removeReturnTrip: "Remove return trip",
selectDate: "Select date",
clockSuffix: "",
back: "Back",
date: "Date",
time: "Time",
apply: "Apply",
pleaseChoose: "Please choose",
cityAirport: "City / Airport",
addReturnTrip: "Add return trip",
closeForm: "Close form",
transferMode: "Transfer",
flightsMode: "Flights",
slide: "Slide",
hotline: "Hotline",
email: "Email",
enterStartAddressError: "Please enter a starting address",
selectAddressFromListError: "Please select an address from the list",
enterDestinationAddressError: "Please enter a destination address",
dateRequiredError: "Date required",
timeRequiredError: "Time required",
departureTimeMinOneHourError: "Departure time must be at least 1 hour in the future",
returnDateRequiredError: "Return date required",
returnTimeRequiredError: "Return time required",
returnTimeMinOneHourError: "Return time must be at least 1 hour in the future",
services: "Services",
  waitingTime: "Waiting time",
  waitingTimeDescription: "The driver waits longer for you – bookable in 15-minute steps.",
  pickupAdjust: "Pickup time adjustment for flight delays",
  pickupAdjustDescription: "If your flight is delayed, we automatically move your pickup time – your driver will wait for you.",
  waitingFreeIncluded: "{min} min free of charge included",
  waitingEachExtra: "each additional {min} min {price} €",
  flightRequiredForAdjust: "Please enter your flight number (e.g. LH123) for the pickup time adjustment you booked.",
  sessionExpiredTitle: "Session expired",
  sessionExpiredText: "For security reasons you have been signed out. Please sign in again – your data has not been lost.",
  sessionExpiredButton: "Go to sign in",
  flightHintTitle: "Does your pickup time fit your landing?",
  flightHintText: "Your flight {flight} is expected to land at {landing} – your booked pickup time ({pickup}) is before that. Please choose a pickup time after landing:",
  flightHintKeep: "Keep pickup time {pickup}",
  flightHintChanged: "Your pickup time was changed to {time}.",
  flightHintReturnPrefix: "Return trip",
  tabCancelled: "Cancelled"
};

export default translations;
